import Child from './Child';

export default class ParentUser {
    fullName() {
        let fullName = this.lastName;

        if (this.firstName) {
            fullName = `${this.firstName} ${fullName}`;
        }

        return fullName;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        const parentUser = new ParentUser();
        parentUser.id = data.id;
        parentUser.firstName = data.firstname;
        parentUser.lastName = data.lastname;
        parentUser.statuses = data.statuses;
        parentUser.kindergartenId = data.kindergarten_id;

        parentUser.children = [];
        if (data.children && data.children.data) {
            parentUser.children = data.children.data.map((data) => Child.fromData(data));
        }

        Object.seal(parentUser);
        return parentUser;
    }
}
